/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { I } from './i';
/**
 *
 *
 * @export
 * @interface AtlasConfigDto
 */
export interface AtlasConfigDto {
  /**
   * Chest size.
   *
   * @type {string}
   * @memberof AtlasConfigDto
   * @example M
   */
  chest_size: AtlasConfigDtoChestSizeEnum;

  /**
   * Shoe size.
   *
   * @type {number}
   * @memberof AtlasConfigDto
   * @example 25
   */
  shoe_size: AtlasConfigDtoShoeSizeEnum;

  /**
   * Left femur length.
   *
   * @type {I}
   * @memberof AtlasConfigDto
   * @example 24
   */
  femur_len_l: I;

  /**
   * Right femur length.
   *
   * @type {I}
   * @memberof AtlasConfigDto
   * @example 24
   */
  femur_len_r: I;

  /**
   * Left tibia length.
   *
   * @type {I}
   * @memberof AtlasConfigDto
   * @example 23
   */
  tibia_len_l: I;

  /**
   * Right tibia length.
   *
   * @type {I}
   * @memberof AtlasConfigDto
   * @example 23
   */
  tibia_len_r: I;

  /**
   * Hip width in centimeters (Atlas).
   *
   * @type {number}
   * @memberof AtlasConfigDto
   * @example 33
   */
  hip_width: number;

  /**
   * Hip flexion.
   *
   * @type {number}
   * @memberof AtlasConfigDto
   * @example 10
   */
  flexos_hip: number;

  /**
   * Knee flexion.
   *
   * @type {number}
   * @memberof AtlasConfigDto
   * @example 15
   */
  flexos_knee: number;

  /**
   * Height of the Atlas frame.
   *
   * @type {number}
   * @memberof AtlasConfigDto
   * @example 100
   */
  height_marco_atlas: number;

  /**
   * Maximum plantar flexion.
   *
   * @type {number}
   * @memberof AtlasConfigDto
   * @example -10
   */
  flex_plantar_max: number;

  /**
   * Maximum dorsal flexion.
   *
   * @type {number}
   * @memberof AtlasConfigDto
   * @example 0
   */
  flex_dorsal_max: number;

  /**
   * Ankle position in stance phase.
   *
   * @type {number}
   * @memberof AtlasConfigDto
   * @example 5
   */
  ankle_stance: number;

  /**
   * Abduction right.
   *
   * @type {number}
   * @memberof AtlasConfigDto
   * @example 5
   */
  abdr: number;

  /**
   * Abduction left.
   *
   * @type {number}
   * @memberof AtlasConfigDto
   * @example 5
   */
  abdl: number;

  /**
   * Hip range of motion.
   *
   * @type {number}
   * @memberof AtlasConfigDto
   * @example 60
   */
  rom_hip: number;

  /**
   * Knee range of motion.
   *
   * @type {number}
   * @memberof AtlasConfigDto
   * @example 90
   */
  rom_knee: number;

  /**
   * Ankle range of motion.
   *
   * @type {number}
   * @memberof AtlasConfigDto
   * @example 30
   */
  rom_ankle: number;
}

/**
 * @export
 * @enum {string}
 */
export enum AtlasConfigDtoChestSizeEnum {
  M = 'M',
  L = 'L',
}
/**
 * @export
 * @enum {string}
 */
export enum AtlasConfigDtoShoeSizeEnum {
  NUMBER_27 = 27,
  NUMBER_30 = 30,
  NUMBER_33 = 33,
}
